import React from "react";
import "./style.scss";

export default function Health({ health = {} }) {
  const { Height, Weight, BloodTypeName } = health;
  return (
    <React.Fragment>
      <div className="form-readonly ma-2">
        <div className="form-col">
          <div className="form-group">
            <div className="form-label">Blood Type Name</div>
            <div className="form-value">
              <span>{BloodTypeName}</span>
            </div>
          </div>
        </div>
        <div className="form-col">
          <div className="form-group">
            <div className="form-label">Height</div>
            <div className="form-value">
              <span>{Height}</span>
            </div>
          </div>
        </div>
        <div className="form-col">
          <div className="form-group">
            <div className="form-label">Weight</div>
            <div className="form-value">
              <span>{Weight}</span>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
}
